module.exports = __webpack_public_path__ + "static/media/kev.e6407ee4.jpg";